import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'
import { leaseTypes } from 'modules/api/portfolio/constants'

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  step: getStep(PortfolioWizardStepNames.invoices),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Invoice templates',
  description:
    chatbotSelectors.getCurrentLeaseType(state) === leaseTypes.unmanaged
      ? 'These templates will generate invoices when the lease is activated.'
      : 'These templates will generate invoices when the lease is activated. Monthly recurring templates will generate on the 10th of every month until the lease expires or is terminated.',
  displayDescription: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
